import { Component, OnInit, Inject, PLATFORM_ID, OnDestroy, AfterViewInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../core/authentication/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable ,} from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {

  slides = new Array(20);
  imgSrc: object = {};
  banner = [
    {
      url: `/assets/theme/resources/images/landing-page/banner.jpg`,
      title: 'TitleBanner1',
      caption: 'CaptionBanner1'
    },
    {
      url: `/assets/theme/resources/images/landing-page/banner-2.jpg`,
      title: 'TitleBanner2',
      caption: 'CaptionBanner2'
    },
    {
      url: `/assets/theme/resources/images/landing-page/banner-3.jpg`,
      title: 'TitleBanner3',
      caption: 'CaptionBanner3'
    }
  ];
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
    @Inject(PLATFORM_ID) private platformId
  ) {
    this.translate.onLangChange.subscribe(({ lang, translations }) => {
      this.imgSrc = this.getAccordingPic(lang);
    });
    this.authenticationService.getIsAuthorized().subscribe(isAuthorized => {
      if (isAuthorized) {
        this.router.navigate(['/']);
      }
    });

  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const currentLang =  localStorage.getItem('language');
      this.imgSrc = this.getAccordingPic(currentLang);
      window.onbeforeunload = () => this.ngOnDestroy();
    }


   

  }
  ngAfterViewInit(): void {
    // tslint:disable-next-line: no-unused-expression
    const swiper: any = new Swiper('.swiper-container', {
      direction: 'horizontal',
      loop: true,
      speed: 600,
      grabCursor: true,
      autoplay: {
        delay: 1500,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      observer: true,
      observeParents: true,
      slidesPerView: 4,
      navigation: {
        nextEl: '.supplier-swiper-button-next',
        prevEl: '.supplier-swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        411: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 50,
        },
      }
    });

  }

  goLogin() {
    this.authenticationService.login();
  }

  goForBuyer() {
    this.router.navigate(['/for-buyer']);
  }

  goForCarrier() {
    this.router.navigate(['/for-carrier']);
  }

  goRegister() {
    this.authenticationService.register();
  }

  getAccordingPic(currentLang): object {
    let imgs = {
      img1: '/assets/theme/resources/images/landing-page/img-01.png',
      img2: '/assets/theme/resources/images/landing-page/img-02.png'
    };
    switch (currentLang) {
      case 'en':
        imgs = {
          img1: '/assets/theme/resources/images/landing-page/img-01.png',
          img2: '/assets/theme/resources/images/landing-page/img-02.png'
        };
        break;
      case 'zh-cn':
        imgs = {
          img1: '/assets/theme/resources/images/landing-page/img-01-SC.png',
          img2: '/assets/theme/resources/images/landing-page/img-02-SC.png'
        };
        break;
      case 'zh-hk':
        imgs = {
          img1: '/assets/theme/resources/images/landing-page/img-01-TC.png',
          img2: '/assets/theme/resources/images/landing-page/img-02-TC.png'
        };
        break;
    }
    return imgs;
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('showPopupPreRegistration');
    }
  }
}
